import { render, staticRenderFns } from "./dbp.vue?vue&type=template&id=5b35dcb8&scoped=true"
import script from "./dbp.vue?vue&type=script&lang=js"
export * from "./dbp.vue?vue&type=script&lang=js"
import style0 from "./dbp.vue?vue&type=style&index=0&id=5b35dcb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35dcb8",
  null
  
)

export default component.exports